module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.0.1-65.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.0.1.md
// module id = 483
// module chunks = 378